import React, { useEffect } from 'react';
import { string, func, number } from 'prop-types';
import { getJdxSession, refreshJdxTimeout } from './../../actions/session';
import { connect } from 'react-redux';
import { timeoutMs } from './JDXUtils';
import './JDXIframe.scss';

JDXIframe.propTypes = {
  jdxSessionKey: string,
  jdxSessionTime: number,
  masterAccountId: string,
  jdxUrl: string,
  getJdxSession: func,
  refreshJdxTimeout: func
};
function JDXIframe({ jdxSessionKey, jdxSessionTime, masterAccountId, jdxUrl, getJdxSession, refreshJdxTimeout }) {
  // timeDiff will indicate how many ms over the timeout its been
  let timeDiff = (jdxSessionTime ? Date.now() - jdxSessionTime : 0) - timeoutMs;
  if (timeDiff < 0) timeDiff = 0;

  useEffect(() => {
    if (jdxSessionKey && !timeDiff) refreshJdxTimeout();
    else if (masterAccountId) getJdxSession(masterAccountId);
  }, [timeDiff]);

  if (!jdxSessionKey || !jdxSessionTime || !jdxUrl) {
    return <div className="jdx-iframe__container"></div>;
  }
  const url = `${jdxUrl}/post.frmWebAuthForm.wgx?SessionKey=${jdxSessionKey}&Action=MainV2&Parameter=0001`;
  return (
    <div className="jdx-iframe__container">
      <iframe className="idx-iframe__iframe" src={url}></iframe>
    </div>
  );
}

const mapStateToProps = ({ session }) => {
  return {
    jdxSessionKey: session.jdxSessionKey,
    jdxSessionTime: session.jdxSessionTime,
    jdxUrl: session.organization.accountMetaData.hrtmsUrl,
    masterAccountId: session.organization.masterAccountId
  };
};

const actions = { getJdxSession, refreshJdxTimeout };

export default connect(mapStateToProps, actions)(JDXIframe);
